import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function GetUpPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboarding.getUp.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-orange"
          emoji="🕑"
          label={t("pages.onboarding.getUp.between0And10")}
          name={t("pages.onboarding.getUp.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.getUp.between0And10", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="🕑"
          label={t("pages.onboarding.getUp.between10And20")}
          name={t("pages.onboarding.getUp.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.getUp.between10And20", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-peach"
          emoji="🕑"
          label={t("pages.onboarding.getUp.between20And30")}
          name={t("pages.onboarding.getUp.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.getUp.between20And30", { lng: "en" })}
        />

        <RadioInputButton
          className="from-pd-blue"
          emoji="🕑"
          label={t("pages.onboarding.getUp.moreThan30")}
          name={t("pages.onboarding.getUp.heading", { lng: "en" })}
          onChange={handleChange}
          value={t("pages.onboarding.getUp.moreThan30", { lng: "en" })}
        />
      </Form>
    </Layout>
  )
}
